<template>
  <i ref="icon" :class="[ns.b('close'), hover && ns.bm('hover', hover)]" />
</template>

<script lang="ts" setup>
import { useNamespace } from '@vuesax-plus/hooks'
import { closeProps } from './close'

defineOptions({
  name: 'IconClose',
})

defineProps(closeProps)

const ns = useNamespace('icon')
</script>
